@if (emailNotVerified()) {
<div class="swm__email-warning">
  <i-tabler name="mail-exclamation" class="icon-18"></i-tabler>
  {{ 'stores.invitations.emailNotVerifiedHint' | translate }}
</div>
} @else if (viewMode() === 'grid') {
<app-treeslo-grid #pendingGrid data-tour="pending-invitations-grid" [config]="pendingGridConfig!">
  <ng-template appTableColumnTemplate="provider" let-row>
    <div class="stores-grid-provider-logo">
      @if (isAmazonProvider(row.provider)) {
      <span class="provider-logo-wrap">
        <img class="provider-logo provider-logo--light" src="assets/images/providers-logos/amazon.png" [alt]="row.provider" />
        <img class="provider-logo provider-logo--dark" src="assets/images/providers-logos/amazon-white.png" [alt]="row.provider" />
      </span>
      } @else {
      <img class="provider-logo" [src]="getProviderLogo(row.provider)" [alt]="row.provider" />
      }
    </div>
  </ng-template>
  <ng-template appTableColumnTemplate="invitedAt" let-row>
    {{ row.invitedAt ? (row.invitedAt | date:'mediumDate') : '---' }}
  </ng-template>
  <ng-template appTableColumnTemplate="expiresAt" let-row>
    {{ row.expiresAt ? (row.expiresAt | date:'mediumDate') : '---' }}
  </ng-template>
</app-treeslo-grid>
} @else {
@for (inv of invitations(); track inv.storeId) {
<app-store-card
  cdkDrag
  [cdkDragDisabled]="dragDisabled()"
  [cdkDragData]="inv"
  (cdkDragStarted)="dragStarted.emit()"
  (cdkDragEnded)="dragEnded.emit()"
  mode="pending"
  [invitation]="inv"
  [isAccepting]="acceptingStoreId() === inv.storeId"
  (acceptInvitation)="accept($event)">
</app-store-card>
}
}
